import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.test';

import { BranchOfficeSimpleJson } from './microservices/json/branch-office-simple.json';
import { BranchOfficeJson } from './microservices/json/branch-office.json';
import { ItemActiveJson } from './microservices/json/item-active.json';
import { NumberJson } from './microservices/json/number.json';
import { MicroResponse } from './microservices/response/micro.response';

@Injectable({ providedIn: 'root' })
export class BranchOfficeService {
  private endpoint = environment.IDEMPIER_GATEWAY + '/v1/branchoffice';
  private http = inject(HttpClient);

  get(id: number): Observable<MicroResponse<BranchOfficeJson>> {
    return this.http.get<MicroResponse<BranchOfficeJson>>(
      this.endpoint + `/${id}`,
    );
  }

  getByEstablishment(
    id: number,
  ): Observable<MicroResponse<Array<BranchOfficeSimpleJson>>> {
    return this.http.get<MicroResponse<Array<BranchOfficeSimpleJson>>>(
      this.endpoint,
    );
  }

  getNextBranchOfficeNumber(
    establishmentId: number,
  ): Observable<MicroResponse<NumberJson>> {
    return this.http.get<MicroResponse<NumberJson>>(
      this.endpoint + `/nextNumber?establishmentId=${establishmentId}`,
    );
  }

  save(params: BranchOfficeJson): Observable<MicroResponse<BranchOfficeJson>> {
    return this.http.post<MicroResponse<BranchOfficeJson>>(
      this.endpoint,
      params,
    );
  }

  update(
    params: BranchOfficeJson,
  ): Observable<MicroResponse<BranchOfficeJson>> {
    return this.http.put<MicroResponse<BranchOfficeJson>>(
      this.endpoint,
      params,
    );
  }

  updateActive(
    params: ItemActiveJson,
  ): Observable<MicroResponse<BranchOfficeJson>> {
    return this.http.put<MicroResponse<BranchOfficeJson>>(
      this.endpoint,
      params,
    );
  }
}
